/**
 * This is default flickity carousel class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import Flickity from "flickity";
import { flickitySettleHandler } from "../utils/flickity";

export default class VideoCarousel {
  constructor(elem, APP) {
    this.elem = elem;
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.slideIndex = this.elem.querySelector(".js-vcarousel-index");
    this.slideTotal = this.elem.querySelector(".js-vcarousel-total");
    this.slideHeight = 0;
    this.flkty;
    this.videoPlayers = [];
    this.currentSlideIndex = 0;
    this.fakeTrigger = this.elem.querySelector(".js-fake-video-trigger");
    this.videoButtons = this.elem.querySelectorAll(".js-btn-video");

    // todo
    this.windowWidth = window.innerWidth;
  }

  resizeCarousel() {
    if (this.windowWidth != window.innerWidth) {
      this.flkty.destroy();
      this.setupCarousel();

      this.slideHeight = 0;
      this.windowWidth = window.innerWidth;
    }
  }

  updateVideoState(index) {
    this.videoPlayers.forEach((vp, i) => {
      if (vp.type === "video") {
        if (i === index) {
          vp.video.play();
        } else {
          vp.video.pause();
        }
      }
    });
  }

  setupCarousel() {
    this.flkty = new Flickity(this.carousel, {
      // setGallerySize: false,
      accessibility: false,
      prevNextButtons: this.elem.dataset.length > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "left",
      adaptiveHeight: true,
      // contain: true,
      on: {
        ready: () => {
          if(this.elem.dataset.length > 1) {
            this.slideTotal.innerText = this.slides.length;
          }
        },
        change: (index) => {
          if(this.elem.dataset.length > 1) {
            this.slideIndex.innerText = index + 1;
          }
          this.currentSlideIndex = index;
          this.flkty.resize();
          this.updateVideoState(index);
        },
        settle: () => {
          flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        },
      },
    });
  }

  setupVideos() {
    this.slides.forEach((slide, index) => {
      let slideVideo;

      if (slide.dataset.type === "video") {
        slideVideo = slide.querySelector(".js-mp4");
        if (index === 0) {
          slideVideo.play();
        }
      }

      this.videoPlayers[index] = {
        type: slide.dataset.type,
        video: slide.dataset.type === "video" ? slideVideo : false,
      };
    });
  }

  init() {
    this.setupCarousel();

    window.addEventListener("VideoModalEnabled", (e) => {
      this.updateVideoState(-1);
    });

    window.addEventListener("VideoModalDisabled", (e) => {
      this.updateVideoState(this.currentSlideIndex);
    });

    window.addEventListener("load", () => {
      if (this.flkty) {
        this.flkty.resize();
      }
    });

    // added fake video trigger on dt since it need to be sticky on the carousel
    this.fakeTrigger.addEventListener("click", (e) => {
      this.videoButtons[this.currentSlideIndex].click();
    })

    this.setupVideos();

    // if(this.elem.classList.contains('spf-carousel')) {
    //   window.addEventListener("resize", () => {
    //     this.resizeCarousel();
    //   })
    // }
  }
}
